const language = window.meta.region_configuration.region;

export const formatWeekday = (dateString, long = false) => {
    const date = new Date(dateString);

    let showLang = 'de-DE';

    if (language === 'ch') {
        showLang = 'en-US';
    }

    return date.toLocaleDateString(showLang, { weekday: long ? 'long' : 'short' });
};

export const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const formatDateString = (dateString) => {
    try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            throw new Error('Invalid date format');
        }

        let showLang = 'de-DE';

        if (language === 'ch') {
            showLang = 'en-US';
        }

        return new Intl.DateTimeFormat(showLang, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).format(date);
    } catch (error) {
        console.error('Error formatting date:', error.message);

        return null;
    }
};

export const subtractDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() - days);

    return result.toISOString().split('T')[0];
};

export const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);

    return result.toISOString().split('T')[0];
};
